<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" width="1000px">
        <div class="formContent">
            <el-form ref="form" :model="dioForm" :rules="rules" label-width="160px">
                <el-form-item :label="$t('public.table_scope')" prop="scopeId" v-if="sysAdmin === 'isSysNoAdmin' || sysAdmin === 'isSysAdmin'">
                    <el-select v-model="dioForm.scopeId" style="width:250px" @change="changeFn">
                        <el-option v-for="item in scopeArray" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item :label="$t('integration.collection_unit')" prop="collectUnit">
                    <el-select v-model="dioForm.collectUnit" style="width:250px" @change="changeUnit">
                        <el-option v-for="item in unitArray" :key="item.code" :label="item.name" :value="item.code"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('integration.collection_strategy')" prop="strategy">
                    <el-select v-model="dioForm.strategy" style="width:250px">
                        <el-option v-for="item in strategyArray" :key="item.id" :label="$t(`integration.collection_strategy_${item.id}`)" :value="item.id"> </el-option>
                    </el-select>
                  <el-tooltip
                    v-if="dioForm.strategy"
                    :content="$t(`integration.collection_strategy_des_${dioForm.strategy}`)"
                    placement="top"
                    effect="dark"
                  >
                    <i class="el-icon-question" style="margin-left:10px;cursor: pointer; vertical-align: middle;"></i>
                  </el-tooltip>
                </el-form-item>
                <el-form-item :label="$t('integration.specified_time')" prop="weekDay" v-if="dioForm.collectUnit">
                    <div class="timePoint">
                        <div class="allChooze">
                            <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate" @change="handleCheckAllChange"></el-checkbox>
                        </div>
                        <div class="weekClass">
                            <el-checkbox-group v-model="dioForm.weekDay" @change="handleCheckedCitiesChange">
                                <ul>
                                    <li v-for="item in weekArray" :key="item.id" class="uk-flex uk-flex-middle">
                                        <span>{{ $t(item.text) }}</span>
                                        <el-checkbox class="checkbox" :label="item.id" :key="item.id"></el-checkbox>
                                    </li>
                                </ul>
                            </el-checkbox-group>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item :label="$t('integration.record_point')" prop="timePoint">
                    <div class="timePointClass">
                        <div>
                            <div class="recordPoint">
                                <div class="content" v-for="(item, index) in recordArray" :key="index">
                                    <div class="recordContent">{{ item }}</div>
                                    <span class="iconClass" @click="deleteTimeFn(index)">
                                        <i class="el-icon-close"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <span class="downIcon" @click="handleDownFn">
                            <i class="el-icon-caret-bottom"></i>
                            <div v-show="isChoozeTime" class="selectTime">
                                <div class="timeClass">
                                    <div class="timehour">
                                        <el-select v-model="value1" :placeholder="$t('public.please')">
                                            <el-option v-for="item in hourArray" :key="item" :label="item" :value="item"></el-option>
                                        </el-select>
                                    </div>
                                    <span class="maohao">:</span>
                                    <div class="timemin">
                                        <el-select v-model="value2" :placeholder="$t('public.please')">
                                            <el-option v-for="item in minArray" :key="item" :label="item" :value="item"> </el-option>
                                        </el-select>
                                    </div>
                                    <div class="checkIcon" @click="handleConfrimFn">
                                        <i class="el-icon-check"></i>
                                    </div>
                                </div>
                            </div>
                        </span>
                    </div>
                    <!--  -->
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
            <el-button type="primary" @click="resolveFn">{{ $t('integration.confirm') }}</el-button>
        </div>
    </modal>
</template>

<script>
import { accessRangeTree } from '@/api/api.js';
import { carrierRecordDetail, carrieSet, carrierDetail, carrierStrategy } from '@/api/modules/record.js';
import { getLanguage } from '@/lang';

export default {
    props: ['isShow', 'scopeId', 'detailRow'],
    watch: {
        scopeId(newVal) {
            this.dioForm.scopeId = newVal;
        },
        detailRow(newVal) {
            if (newVal) {
                this.isChoozeTime = false;
                this.desc = newVal.desc;
                newVal.scopeId = String(newVal.scopeId);
                this.dioForm = { ...newVal };
                this.dioForm.weekDay = newVal.weekDay.split(',');
                this.recordArray = this.dioForm.timePoint.split(',');
                //  = true
                this.checkAll = this.dioForm.weekDay.length === 7;
                this.isIndeterminate = this.dioForm.weekDay.length > 0 && this.dioForm.weekDay.length < 7;
            } else {
                this.dioForm = {
                    scopeId: '',
                    weekDay: [],
                    timePoint: '',
                    collectUnit: '',
                    strategy: ''
                };
                this.dioForm.scopeId = this.scopeId + '';
                this.recordArray = [];
                this.checkAll = false;
                this.clearValidate();
            }
        }
    },
    computed: {
        isShowDialog: {
            get: function() {
                return this.isShow;
            },
            set: function(val) {
                this.$emit('update:isShow', val);
            }
        },
        rules() {
            const pointFn = (rules, value, cb) => {
                if (this.recordArray.length === 0) {
                    cb($t('integration.record_point_cannot_be_empty'));
                }
                cb();
            };
            return {
                collectUnit: [{ required: true, message: $t('integration.collection_unit_cannot_be_empty'), trigger: 'change' }],
                strategy: [{ required: true, message: $t('integration.collection_unit_cannot_be_empty'), trigger: 'change' }],
                weekDay: [{ required: true, message: $t('integration.the_specified_time_cannot_be_empty'), trigger: 'change' }],
                timePoint: [{ validator: pointFn, trigger: 'blur', required: true }]
            };
        },
        /** 用于表示当前登录用户属于什么类型的角色 */
        sysAdmin() {
            const currentUser = this.$store.getters.userInfo.scope;
            if (currentUser.sysScope && currentUser.sysAdmin) {
                // 系统管理员
                return 'isSysAdmin';
            } else if (currentUser.sysScope && !currentUser.sysAdmin) {
                // 系统非管理员
                return 'isSysNoAdmin';
            } else if ((!currentUser.sysScope && currentUser.scopeAdmin) || currentUser.type === 2) {
                // 非系统管理员 以及代理角色  代理角色是迭代7的需求添加
                return 'noSysIsAdmin';
            } else {
                // 非系统非管理员
                return 'noSysNoAdmin';
            }
        },
        i18n() {
            return this.$i18n.locale;
        }
    },
    data() {
        return {
            title: $t('integration.record_point_setting'),
            scopeArray: [],
            unitArray: [],
            strategyArray: [],
            dioForm: {
                scopeId: '',
                weekDay: [],
                timePoint: '',
                collectUnit: '',
                strategy: ''
            },
            weekArray: [
                {
                    id: '1',
                    text: $t('public.monday'),
                    check: false
                },
                {
                    id: '2',
                    text: $t('public.tuesday'),
                    check: false
                },
                {
                    id: '3',
                    text: $t('public.wednesday'),
                    check: false
                },
                {
                    id: '4',
                    text: $t('public.thursday'),
                    check: false
                },
                {
                    id: '5',
                    text: $t('public.friday'),
                    check: false
                },
                {
                    id: '6',
                    text: $t('public.saturday'),
                    check: false
                },
                {
                    id: '0',
                    text: $t('public.sunday'),
                    check: false
                }
            ],
            checkAll: false,
            isIndeterminate: false,
            checkedWeeks: [],
            recordArray: [],
            vlueNull: null,
            value1: '01',
            value2: '01',
            isChoozeTime: false,
            allChoozeArray: ['1', '2', '3', '4', '5', '6', '0'],
            hourArray: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
            minArray: [
                '00',
                '01',
                '02',
                '03',
                '04',
                '05',
                '06',
                '07',
                '08',
                '09',
                '10',
                '11',
                '12',
                '13',
                '14',
                '15',
                '16',
                '17',
                '18',
                '19',
                '20',
                '21',
                '22',
                '23',
                '24',
                '25',
                '26',
                '27',
                '28',
                '29',
                '30',
                '31',
                '32',
                '33',
                '34',
                '35',
                '36',
                '37',
                '38',
                '39',
                '40',
                '41',
                '42',
                '43',
                '44',
                '45',
                '46',
                '47',
                '48',
                '49',
                '50',
                '51',
                '52',
                '53',
                '54',
                '55',
                '56',
                '57',
                '58',
                '59'
            ],
            desc: '',
            getLanguage
        };
    },
    methods: {
        /** 获取数据 */
        getSence() {
            if (this.scopeArray.length > 0) return;
            const P1 = accessRangeTree({ local: this.i18n });
            const P2 = carrierRecordDetail({ code: 'acquisition_unit', type: 0 });
            const P3 = carrierStrategy();
            Promise.all([P1, P2, P3]).then(res => {
                this.scopeArray = res[0].result.filter(item => {
                    return item.id > 0;
                });
                this.unitArray = res[1].result.map(item => {
                    return {
                        code: Number(item.code),
                        name: getLanguage() === 'zh_CN'?item.name:item.content
                    };
                });

              this.strategyArray = res[2].result.map(item => {
                return {
                  ...item, // 保留原有所有字段
                  title: this.$t('integration.collection_strategy_des_' + item.id) // 新增 label 字段存放翻译结果
                };
              });


              this.desc = res[2].result[0].desc;
                console.log('this.strategyArray==>', this.strategyArray);
            });
        },
        /** 全选 */
        handleCheckAllChange(val) {
            this.dioForm.weekDay = val ? this.allChoozeArray : [];
            this.isIndeterminate = false;
        },
        handleCheckedCitiesChange(value) {
            const checkedCount = value.length;
            this.checkAll = checkedCount === this.weekArray.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.weekArray.length;
        },
        handleDownFn() {
            this.isChoozeTime = !this.isChoozeTime;
        },
        clearValidate() {
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.resetFields();
                }
            });
        },
        async justify() {
            try {
                return await this.$refs.form.validate();
            } catch (error) {
                return false;
            }
        },
        async resolveFn() {
            // if (this.recordArray.length === 0) return this.$message.warning($t('integration.record_point_cannot_be_empty'));
            const flag = await this.justify();
            if (!flag) return;
            const { id, scopeId, collectUnit, strategy, weekDay } = this.dioForm;
            const timePoint = this.recordArray.join(',');
            const query = { id, scopeId, collectUnit, strategy, weekDay: weekDay.join(','), timePoint };
            carrieSet(query).then(({ result }) => {
                if (result === 1) {
                    this.$message.success($t('integration.set_successfully'));
                    this.isShowDialog = false;
                } else if (result === 0) {
                    this.$message.error($t('integration.setting_failed'));
                } else if (result === 2) {
                    this.$message.error($t('integration.system_error'));
                } else if (result === 3) {
                    this.$message.error($t('integration.data_already_exists'));
                } else if (result === 4) {
                    this.$message.error($t('integration.record_point_time_repetition'));
                }
            });
        },
        handleConfrimFn() {
            const str = this.value1 + ':' + this.value2;
            let flag = true;
            for (const item of this.recordArray) {
                if (item === str) {
                    flag = false;
                    break;
                }
            }
            if (!flag) return this.$message.warning($t('integration.record_points_cannot_be_repeated'));
            this.$refs.form.clearValidate('timePoint');
            this.recordArray.push(str);
        },
        deleteTimeFn(index) {
            if (this.recordArray.length === 1) return this.$message.warning($t('integration.keep_at_least_one_point_in_time'));
            this.recordArray.splice(index, 1);
        },
        changeFn(scopeId) {
            console.log('type==>', scopeId);
            carrierDetail({ scopeId: scopeId }).then(({ result }) => {
                if (result) {
                    this.isChoozeTime = false;
                    // this.desc = result.desc || '';
                    this.dioForm = { ...result };
                    this.dioForm.scopeId = scopeId;
                    this.dioForm.weekDay = result.weekDay.split(',');
                    this.recordArray = this.dioForm.timePoint.split(',');
                    //  = true
                    this.checkAll = this.dioForm.weekDay.length === 7;
                }
                console.log('this.dioForm==>', this.dioForm);
                this.getSence();
            });
        },
        changeUnit(e) {
            console.log(e);
        }
    }
};
</script>

<style lang="scss" scoped>
.formContent {
    min-height: 500px;
}

.timePoint {
    height: 40px;
    width: 770px;
    border: 1px solid #ccc;
    display: flex;
    box-sizing: border-box;
    border-radius: 2px;
    .allChooze {
        width: 40px;
        height: 100%;
        text-align: center;
        line-height: 40px;
        border-right: 1px solid #ccc;
        flex-shrink: 0;
    }

    .weekClass {
        flex: 1;
        overflow: hidden;
        ul {
            height: 100%;
            display: flex;
            align-items: center;
            padding: 5px;
            box-sizing: border-box;

            li {
                height: 30px;
                margin-right: 5px;
                display: inline-flex;
                flex-shrink: 0;

                span {
                    min-width: 50px;
                    height: 30px;
                    line-height: 30px;
                    text-align: center;
                    display: inline-block;
                    background-color: var(--primary-color);
                    color: #fff;
                    border-radius: 2px 0 0 2px;
                    padding: 0 6px;
                    white-space: nowrap;
                    box-sizing: border-box;
                }

                .checkbox {
                    border: 1px solid #ccc;
                    box-sizing: border-box;
                    width: 30px;
                    height: 30px;
                    border-radius: 0 2px 2px 0;
                    flex-shrink: 0;
                    text-align: center;
                    line-height: 30px;
                    ::v-deep .el-checkbox {
                        margin-right: 0;
                    }
                    ::v-deep .el-checkbox__label {
                        display: none;
                    }
                    ::v-deep .el-checkbox__inner {
                        vertical-align: middle;
                    }
                }
            }
        }
    }
}

.timePointClass {
    display: flex;
    align-items: center;
    width: 550px;

    .downIcon {
        cursor: pointer;
        position: relative;

        i {
            font-size: 22px;
            font-weight: bold;
        }

        .selectTime {
            position: absolute;
            top: 31px;
            margin-left: 5px;
            width: 240px;
            height: 40px;
            border: 1px solid #ccc;
        }

        .timeClass {
            display: flex;
            height: 100%;
            width: 100%;

            .timehour,
            .timemin {
                flex: 1;
                padding: 0 5px;
                padding-top: 4px;
            }

            .checkIcon {
                width: 40px;
                height: 100%;
                text-align: center;
                line-height: 46px;
                border-left: 1px solid #ccc;
            }

            .maohao {
                line-height: 40px;
            }
        }
    }
}

.recordPoint {
    min-height: 40px;
    padding: 5px;
    padding-top: 0;
    border: 1px solid #ccc;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;

    .content {
        display: flex;
        margin-right: 5px;
        margin-top: 5px;
    }

    .recordContent {
        width: 60px;
        height: 28px;
        background-color: var(--primary-color);
        color: #fff;
        text-align: center;
        border-radius: 2px 0px 0px 2px;
    }

    .iconClass {
        display: inline-block;
        width: 26px;
        height: 26px;
        border: 1px solid #ccc;
        text-align: center;
        cursor: pointer;
        border-radius: 0px 2px 2px 0px;

        i {
            font-weight: bold;
        }
    }
}


</style>
